import React from 'react';
import Api from './Config';
import { saveAs } from './FileSaver';

const getBiometricHeading = (category, isLast) => {
  let biometricHeading = [];
  switch (category.toLowerCase()) {
    case 'htn':
      if (isLast) {
        biometricHeading = ['Systolic', 'Diastolic'];
      } else {
        biometricHeading = ['Average Systolic', 'Average Diastolic'];
      }
      break;
    default:
      break;
  }

  return biometricHeading;
};

const getBiometricAnswers = (avgBio, category) => {
  let biometricAnswers = [];
  switch (category.toLowerCase()) {
    case 'htn':
      biometricAnswers = [avgBio.systolic, avgBio.diastolic];
      break;
    default:
      break;
  }

  return biometricAnswers;
};

const AverageResponseCsv = ({ startDate, endDate, csvData, category, title, overAllAvg, isLast }) => {
  const doCsv = async () => {
    let csv = title;
    csv += '\r\n';
    csv += 'Run Date,' + Api.getDateFormat(new Date(), false);

    csv += '\r\n';
    csv +=
      'Date Range,' +
      Api.getDateFormat(new Date(Date.parse(startDate)), false) +
      ',' +
      Api.getDateFormat(new Date(Date.parse(endDate)), false);
    csv += '\r\n';

    const bioHeading = getBiometricHeading(category, isLast);
    const overAllAvgBio = getBiometricAnswers(overAllAvg.average_bio, category);

    bioHeading.forEach((head, index) => {
      csv += head + ',' + overAllAvgBio[index].toFixed(2);
      csv += '\r\n';
    });

    csv += 'Number of Unique Patients,' + overAllAvg.patientCount;
    csv += '\r\n';
    csv += 'Percentage of Patients Under Control,' + (overAllAvg.patientInControlPercent * 100).toFixed(2) + '%';
    csv += '\r\n';
    csv += '\r\n';

    let headings = ['Patient Ref', 'App Code', 'T-Code'];

    if (isLast) {
      headings.push('Last date submitted');
    }

    if (bioHeading.length > 0) {
      headings = [...headings, ...bioHeading];
    }

    csv += headings.join(',');
    csv += '\r\n';

    for (let counter = 0; counter < csvData.length; counter += 1) {
      const rowData = csvData[counter];
      let row = [rowData['patient_ref'], rowData['app_id'], rowData['t_code']];

      if (isLast) {
        const lastSentDate = Api.getDateFormat(new Date(Date.parse(rowData['sentDate'])), false);
        row.push(lastSentDate);
      }

      const bioAnswers = getBiometricAnswers(rowData.avg_bio, category);
      if (bioAnswers.length > 0) {
        row = [...row, ...bioAnswers];
      }

      csv += row.join(',');
      csv += '\r\n';
    }

    const blob = new Blob([csv], { type: 'text/plain;charset=utf-8' });
    saveAs(blob, `${new Date()} - ${title} - report.csv`);
  };

  return (
    <button onClick={doCsv} className="btn btn-primary" type="button">
      <i className="fa fa-download " style={{ marginRight: 5 }} />
      CSV
    </button>
  );
};

export default AverageResponseCsv;
